import { useContext, useEffect, useState } from "react";
import DBTab from "../../../../component/global/DBTab";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import {
    SETTING_FORMS_CRITERIA,
    SETTING_FORMS_LIST,
    SETTING_ITEMS_TYPE_FAETURES,
} from "../../../../helperData/ApiAddress";
import { t } from "i18next";
import "./styles.scss";
import DBSpinner from "../../../../component/global/DBSpinner";
import {
    criteriaTypeList,
    featureTypeList,
    getLanguageCaption,
} from "../../../../feedback/helperFunctions";
import DBTable from "../../../../component/global/DBTable/DBTable";
import {
    Add,
    Copy,
    Edit,
    MagicStar,
    SearchNormal,
    SearchNormal1,
    Trash,
} from "iconsax-react";
import DBPagination from "../../../../component/global/DBPagination";
import DBSwitch from "../../../../component/global/DBSwitch";
import DBButton from "../../../../component/global/DBButton";
import DBAddButton from "../../../../component/global/DBAddButton";
import DBInput from "../../../../component/global/DBInput";
import DBConfirmModal from "./../../../../component/global/DBConfirmModal/index";
import { ToastContext } from "../../../../component/global/ToastContext";
import { SETTING_FORMS } from "../../../../helperData/ApiAddress";
import FormModal from "./FormModal";
import CriteriaModal from "./CriteriaModal";
import AIFormModal from "./AIFormModal";
import Skeleton from "react-loading-skeleton";
import { AiCoinHint } from "../../../../features/ai-billing/AiCoinGate";

export default function FormsTab({ itemtype }) {
    const toast = useContext(ToastContext);

    const [getFeatures, getFeaturesLoader, cancelGetFeatures] = useRequest(
        SETTING_ITEMS_TYPE_FAETURES,
        "GET"
    );

    const [getForms, getFormsLoader, cancelGetForms] = useRequest(
        SETTING_FORMS_LIST,
        "GET",
        undefined,
        true
    );

    const [getFormCriteria, getFormCriteriaLoader, cancelGetFormCriteria] =
        useRequest(SETTING_FORMS_CRITERIA, "GET");

    const [deleteForm, deleteFormLoader] = useRequest(SETTING_FORMS, "DELETE");

    const deleteFormHandle = () => {
        deleteForm(undefined, undefined, selectedForm?.id)
            .then((r) => {
                toast(t("form.delete.successfull"), "success");
                setSelectedForm(undefined);
                getFormsHandle();
                setFormDeleteConfirmModal(false);
            })
            .catch((e) => {
                toast(t("form.delete.error"), "danger");
            });
    };

    const [features, setFeatures] = useState([]);
    const [forms, setForms] = useState([]);
    const [formCriteria, setFormCriteria] = useState([]);
    const [selectedForm, setSelectedForm] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [featuresModalShow, setFeaturesModalShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [searchStr, setSearchStr] = useState("");
    const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
    const [formDeleteConfirmModal, setFormDeleteConfirmModal] = useState(false);

    const [formModalShow, setformModalShow] = useState(false);
    const [formModalEditMode, setformModalEditMode] = useState(false);
    const [aiFormModalShow, setAIFormModalShow] = useState(false);
    const [criteriaModalShow, setCriteriaModalShow] = useState(false);
    const [criteriaModalEditMode, setCriteriaModalEditMode] = useState(false);

    const [deleteCriteria, deleteCriteriaLoader] = useRequest(
        SETTING_FORMS_CRITERIA + deleteConfirmModal + "/",
        "DELETE"
    );

    const [updateCriteria, updateCriteriaLoader] = useRequest(
        SETTING_FORMS_CRITERIA,
        "PATCH"
    );

    const updateAddUploadFileHandle = (id) => {
        const newState = !formCriteria.find((item) => item.id === id)
            .add_upload_file;
        updateCriteria({ add_upload_file: newState }, undefined, id).then(
            (r) => {
                let temp = formCriteria.map((item, ind) =>
                    item.id === id
                        ? { ...item, add_upload_file: newState }
                        : item
                );
                setFormCriteria(temp);
            }
        );
    };

    const updateAddDescriptionHandle = (id) => {
        const newState = !formCriteria.find((item) => item.id === id)
            .add_description;
        updateCriteria({ add_description: newState }, undefined, id).then(
            (r) => {
                let temp = formCriteria.map((item, ind) =>
                    item.id === id
                        ? { ...item, add_description: newState }
                        : item
                );
                setFormCriteria(temp);
            }
        );
    };

    const getFormsHandle = (form) => {
        getForms({
            item_type: itemtype.id,
        }).then((r) => {
            setForms(r);
            if (form) {
                setSelectedForm(form);
            } else {
                setSelectedForm(r[0]);
            }
        });
    };

    const getFormCriteriaHandle = () => {
        getFormCriteria({
            form: selectedForm?.id,
            page: currentPage,
        }).then((r) => {
            setFormCriteria(r.results);
            setTotalPage(r.count);
        });
    };

    useEffect(() => {
        if (itemtype && selectedForm?.id) {
            cancelGetFormCriteria?.();
            getFormCriteriaHandle();
        }
    }, [selectedForm, currentPage]);

    useEffect(() => {
        if (itemtype) {
            cancelGetForms?.();
            cancelGetFormCriteria?.();
            setSelectedForm(undefined);
            getFormsHandle();
        }
    }, [itemtype]);

    const headers = [
        {
            id: "row",
            title: t("criteria.row"),
            gridTemplateColumns: "60px",
        },
        {
            id: "name",
            title: t("criteria.name"),
            gridTemplateColumns: "3fr",
        },
        {
            id: "weight",
            title: t("criteria.weight"),
            gridTemplateColumns: "60px",
        },
        {
            id: "criteriaType",
            title: t("criteria.type"),
            gridTemplateColumns: "100px",
        },
        {
            id: "parent",
            title: t("criteria.parent"),
            gridTemplateColumns: "2fr",
        },
        {
            id: "explanation",
            title: t("criteria.explanation"),
            gridTemplateColumns: "100px",
        },
        {
            id: "attachment",
            title: t("criteria.attachment"),
            gridTemplateColumns: "100px",
        },
        {
            id: "options",
            title: t("criteria.options"),
            gridTemplateColumns: "75px",
        },
    ];

    const rows = formCriteria?.map((item, index) => {
        return {
            row: index + 1,
            name: item.criteria.name,
            weight: item.weight,
            criteriaType: criteriaTypeList[item.criteria_state_type],
            parent: item.criteria.parent || t("criteria.parent.empty"),
            explanation: (
                <div>
                    <DBSwitch
                        loading={updateCriteriaLoader}
                        // disabled={updateCriteriaLoader}
                        checked={item.add_description}
                        onChange={() => updateAddDescriptionHandle(item.id)}
                    />
                </div>
            ),
            attachment: (
                <div>
                    <DBSwitch
                        loading={updateCriteriaLoader}
                        // disabled={updateCriteriaLoader}
                        checked={item.add_upload_file}
                        onChange={() => updateAddUploadFileHandle(item.id)}
                    />
                </div>
            ),
            options: (
                <div className="option-buttons">
                    <Edit
                        size="18"
                        color="#2e71fc"
                        onClick={() => {
                            setCriteriaModalEditMode(item.id);
                            setCriteriaModalShow(true);
                        }}
                    />
                    <Trash
                        size="18"
                        color="red"
                        onClick={() => setDeleteConfirmModal(item.id)}
                    />
                </div>
            ),
        };
    });

    const deleteCriteriaHandle = (_, id) => {
        deleteCriteria(undefined, [{ name: "id", value: id }])
            .then((r) => {
                toast(t("criteria.delete.success"), "success");
                setDeleteConfirmModal(false);
                getFormCriteriaHandle();
            })
            .catch((e) => {
                toast(t("criteria.delete.error"), "danger");
            });
    };

    return (
        <div className="forms-tab">
            <DBConfirmModal
                show={deleteConfirmModal}
                onHide={() => setDeleteConfirmModal(false)}
                btnTitle={t("criteria.delete")}
                onConfirm={deleteCriteriaHandle}
                title={t("criteria.delete")}
                description={t("criteria.delete.message")}
                loading={deleteCriteriaLoader}
            />
            <DBConfirmModal
                show={formDeleteConfirmModal}
                onHide={() => setFormDeleteConfirmModal(false)}
                btnTitle={t("form.delete.title")}
                onConfirm={deleteFormHandle}
                title={t("form.delete.title")}
                description={t("form.delete.message")}
                loading={deleteFormLoader}
            />
            <FormModal
                show={formModalShow}
                onHide={() => setformModalShow(false)}
                editMode={formModalEditMode}
                itemType={itemtype?.id}
                onSuccess={(form) => getFormsHandle(form)}
            />
            <AIFormModal
                show={aiFormModalShow}
                onHide={() => setAIFormModalShow(false)}
                itemType={itemtype}
                onSuccess={(form) => getFormsHandle(form)}
            />
            <CriteriaModal
                show={criteriaModalShow}
                onHide={() => setCriteriaModalShow(false)}
                editMode={criteriaModalEditMode}
                itemType={itemtype}
                selectedForm={selectedForm}
                onSuccess={() => getFormCriteriaHandle()}
            />
            <div className="form-tabbar-con">
                <div className="form-tabbar">
                    {!itemtype ? (
                        <div className="not-itemtype">
                            {t("forms.not.itemtype")}
                        </div>
                    ) : (
                        <div>
                            {getFormsLoader ? (
                                <div style={{ flex: 1 }}>
                                    <Skeleton height={30} />
                                </div>
                            ) : (
                                <>
                                    {forms.length === 0 ? (
                                        <div className="form-zero-length">
                                            <div>{t("form.length.zero")}</div>
                                            <div>
                                                <DBButton
                                                    caption={t("form.create")}
                                                    onClick={() => {
                                                        setformModalEditMode(
                                                            false
                                                        );
                                                        setformModalShow(true);
                                                    }}
                                                />
                                                <DBButton
                                                    caption={
                                                        <>
                                                            <MagicStar
                                                                size={20}
                                                            />
                                                            <span>
                                                                {t(
                                                                    "ai.form.button"
                                                                )}
                                                            </span>
                                                        </>
                                                    }
                                                    type="secondary"
                                                    onClick={() =>
                                                        setAIFormModalShow(true)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {forms.map((form) => (
                                                <div
                                                    className={`form-tab-element ${
                                                        selectedForm?.id ===
                                                        form.id
                                                            ? "selected"
                                                            : ""
                                                    }`}
                                                    onClick={() =>
                                                        setSelectedForm(form)
                                                    }
                                                >
                                                    <span>{form.name}</span>
                                                    <div className="btn-box">
                                                        <Edit
                                                            size={18}
                                                            color="#2e71fc"
                                                            onClick={() => {
                                                                setformModalEditMode(
                                                                    form.id
                                                                );
                                                                setformModalShow(
                                                                    true
                                                                );
                                                            }}
                                                        />
                                                        {/* <Copy
                                                            size={18}
                                                            color="#2e71fc"
                                                        /> */}
                                                        <Trash
                                                            size={18}
                                                            color="red"
                                                            onClick={() =>
                                                                setFormDeleteConfirmModal(
                                                                    true
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                            <div
                                                className="form-tab-element"
                                                onClick={() => {
                                                    setformModalEditMode(false);
                                                    setformModalShow(true);
                                                }}
                                            >
                                                <div className="add-button">
                                                    <Add
                                                        size={24}
                                                        color="#333"
                                                    />
                                                    <span>
                                                        {t(
                                                            "create.form.button"
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className="form-tab-element ai-form-button"
                                                onClick={() =>
                                                    setAIFormModalShow(true)
                                                }
                                            >
                                                <div className="add-button">
                                                    <MagicStar
                                                        size={22}
                                                        color="#2e71fc"
                                                    />
                                                    <span>
                                                        {t("ai.form.button")}
                                                    </span>
                                                    <AiCoinHint operation="form_structure" />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
                {selectedForm && (
                    <div className="criteria-toolbar">
                        <DBButton
                            caption={
                                <>
                                    <Add />
                                    <span>{t("add.new.criteria")}</span>
                                </>
                            }
                            onClick={() => {
                                setCriteriaModalEditMode(false);
                                setCriteriaModalShow(true);
                            }}
                        />
                    </div>
                )}
            </div>
            {selectedForm && (
                <>
                    <div className="criteria-container">
                        {getFormCriteriaLoader ? (
                            <DBSpinner tip={t("loading")} />
                        ) : formCriteria.length === 0 ? (
                            <div className="not-criteria">
                                {t("criteria.empty")}
                            </div>
                        ) : (
                            <DBTable
                                minWidth={700}
                                headers={headers}
                                rows={rows}
                            />
                        )}
                    </div>
                    {formCriteria.length > 0 && (
                        <div className="pagination">
                            <DBPagination
                                total={totalPage}
                                onChange={(page) => {
                                    setCurrentPage(page);
                                }}
                                current={currentPage}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
